import type { UserData } from "../types";
import { apiFetch, apiJson } from "./client";

export interface GoogleVerifyResponse extends UserData {
  tos: string | null;
}

export const verifyGoogleIdToken = (idToken: string) =>
  apiJson<GoogleVerifyResponse>("/auth/google/verify", {
    method: "POST",
    body: JSON.stringify({ id_token: idToken }),
  });

export const fetchMe = () => apiJson<UserData>("/auth/me");

export const logout = () => apiFetch("/logout", { method: "POST" });

export const validateAuth = () => apiJson<{ valid: boolean }>("/auth/validate");
